import RadioStrip    from 'scripts/plugins/radio-strip';
import ControlModule from 'scripts/poppet/control-module';
import template      from 'templates/controlAlarm.jst.html';

/**
 * defa.views.ControlAlarmView
 * A control module for unit alarm.
 * @version 1.3.0
 */

const selectors = {
	mainAlarmStrip: '[data-input=main-alarm-strip]',
	generalAlarmStrip: '[data-input=general-alarm-strip]',
	generalAlarmFollowMainStrip: '[data-input=general-alarm-follow-main-strip]',
};

const ControlAlarmView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:alarm',
	compressedNavState: 'unit:control:overview',
	
	className: function () {
		return this._getClassName( 'control-alarm' );
	},
	
	ui: {
		mainAlarmStrip: selectors.mainAlarmStrip,
		generalAlarmStrip: selectors.generalAlarmStrip,
	},
	
	events: {
		'change @ui.mainAlarmStrip': 'onChangeMainAlarmStrip',
		'change @ui.generalAlarmStrip': 'onChangeGeneralAlarmStrip',
		'change @ui.generalAlarmFollowMainStrip': 'onChangeGeneralAlarmFollowMainStrip',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the html is rendered in the DOM.
	 * @void
	 */
	onDomRefresh: function () {
		const alarmState = this.model.get( 'alarmState' );
		new RadioStrip( selectors.mainAlarmStrip, alarmState );
		new RadioStrip( selectors.generalAlarmStrip, this.model.get('generalAlarmState'));
		new RadioStrip( selectors.generalAlarmFollowMainStrip, this.model.get('generalAlarmFollowMainState'));
	},
	
	onChangeMainAlarmStrip: function ( event, value ) {
		this.model.set({alarmState: value})
			.trigger('sync');
	},
	
	onChangeGeneralAlarmStrip: function ( event, value ) {
		this.model.set({generalAlarmState: value})
			.trigger('sync');
	},
	
	onChangeGeneralAlarmFollowMainStrip: function(event, value) {
		this.model.set({generalAlarmFollowMainState: value})
			.trigger('sync')
	}
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default ControlAlarmView;